import { render, staticRenderFns } from "./TruckAccidentView.vue?vue&type=template&id=ab65161e&"
import script from "./TruckAccidentView.vue?vue&type=script&lang=js&"
export * from "./TruckAccidentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports